/* 맨 위로 가기 — **우리 단추** (2026-10-20 의장 「새로 아이콘을 만들 수는 없냐?
   왜 커졌다작아졌다하는걸 보고있어야하지?」)

   ⛔ 왜 새로 만드나
      종전에는 EffectiveApps 앱이 그린 단추를 받아다 **뒤늦게 55 → 40 으로 줄였다.**
      앱이 먼저 55 로 그리고 우리가 그 다음에 줄이니 **손님 눈에 커졌다 작아졌다 한다.**
      자리도 마찬가지였다 — 앱이 제 자리에 놓은 뒤 우리가 다시 옮겨 **왼쪽으로 튀었다.**
      남의 것을 고쳐 쓰는 한 이 깜빡임은 없앨 수 없다.

   ⇒ 우리가 직접 그린다. **CSS 가 처음부터 제 크기로 그리므로 깜빡임이 없다.**
      · 앱 단추는 숨긴다 (`ue-rhythm.css`)
      · **채널톡은 건드리지 않는다** — 원래 40x40 · 오른쪽 20 · 아래 83 이다(실측 710·1440 동일)
      · 우리 단추도 40x40 · 오른쪽 20, 채널톡 바로 위

   ⚠ 앱을 지우지는 않았다(규정: 앱은 지우지 않는다). 화면에서만 숨긴다. */
(function () {
  'use strict';

  var 나타나는높이 = 300;     /* 이만큼 내려가면 보인다 */
  var 단추 = null;

  function 만들기() {
    if (단추) { return 단추; }
    단추 = document.createElement('button');
    단추.type = 'button';
    단추.className = 'ue-totop';
    단추.setAttribute('aria-label', 'Back to top');
    단추.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 14.5 12 8.5l6 6" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    단추.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(단추);
    return 단추;
  }

  function 보이기() {
    var e = 만들기();
    var 보일까 = window.scrollY > 나타나는높이;
    if (보일까 === e.classList.contains('is-on')) { return; }   /* 이미 그 상태면 아무것도 안 한다 */
    e.classList.toggle('is-on', 보일까);
  }

  /* ── 채널톡에 맞춘다 ─────────────────────────────────────────
     ⛔ 2026-10-20 — 크기·여백을 **못박았다가 틀렸다.**
        데스크톱에서 잰 56 · 오른쪽 20 을 그대로 박았는데, 채널톡은 화면마다 다르다
        (실측: 데스크톱 56x56 오른쪽 20 / 모바일 375 **44x44 오른쪽 25**).
        못박는 한 영영 안 맞는다.
     ⇒ **채널톡을 재서 우리 단추를 거기 맞춘다.** 채널톡은 건드리지 않는다.
     ⚠ 기억에 기대지 않는다 — 지금 그려진 값과 다를 때만 쓴다.
     ⚠ 못 찾으면 CSS 기본값 그대로 둔다. */
  var 찾은톡 = null;

  function 단추같나(n) {
    var r = n.getBoundingClientRect();
    if (r.width < 24 || r.width > 130) { return false; }
    if (Math.abs(r.width - r.height) > 20) { return false; }
    if (r.left < window.innerWidth * 0.5) { return false; }
    if (r.top < window.innerHeight * 0.4) { return false; }
    return true;
  }

  function 뒤져찾기(뿌리, 깊이) {
    if (!뿌리 || 깊이 > 6) { return null; }
    var 것 = 뿌리.querySelectorAll ? 뿌리.querySelectorAll('*') : [];
    for (var i = 0; i < 것.length; i++) {
      var n = 것[i];
      if (단추 && (n === 단추 || 단추.contains(n))) { continue; }
      if (단추같나(n)) { return n; }
      if (n.shadowRoot) {
        var 속 = 뒤져찾기(n.shadowRoot, 깊이 + 1);
        if (속) { return 속; }
      }
    }
    return null;
  }

  function 채널톡() {
    if (찾은톡 && 찾은톡.isConnected && 찾은톡.getBoundingClientRect().width > 0) { return 찾은톡; }
    찾은톡 = null;
    var 이름들 = ['ch-plugin-entry', 'ch-plugin', 'ch-plugin-script'];
    for (var i = 0; i < 이름들.length; i++) {
      var 자리 = document.getElementById(이름들[i]);
      if (자리) { 찾은톡 = 뒤져찾기(자리, 0); }
      if (찾은톡) { return 찾은톡; }
    }
    return null;
  }

  function 맞추기() {
    var e = 만들기();
    var 톡 = 채널톡();
    if (!톡) { return; }
    var k = 톡.getBoundingClientRect();
    if (!k.width) { return; }

    var 크기 = Math.round(k.width);
    var 오른쪽 = Math.round(window.innerWidth - k.right);
    var 아래 = Math.round(window.innerHeight - k.bottom) + 크기 + 12;
    if (크기 < 24 || 크기 > 130 || 오른쪽 < 0 || 오른쪽 > 200) { return; }

    var r = e.getBoundingClientRect();
    if (Math.abs(r.width - 크기) > 0.5) {
      e.style.setProperty('width', 크기 + 'px', 'important');
      e.style.setProperty('height', 크기 + 'px', 'important');
    }
    if (Math.abs(window.innerWidth - r.right - 오른쪽) > 0.5) {
      e.style.setProperty('right', 오른쪽 + 'px', 'important');
    }
    if (Math.abs(window.innerHeight - r.bottom - 아래) > 0.5) {
      e.style.setProperty('bottom', 아래 + 'px', 'important');
    }
  }

  function 시작() {
    만들기();
    보이기();
    맞추기();
    setInterval(맞추기, 1500);
    window.addEventListener('resize', 맞추기);
    var 기다림 = false;
    window.addEventListener('scroll', function () {
      if (기다림) { return; }
      기다림 = true;
      window.requestAnimationFrame(function () { 기다림 = false; 보이기(); });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', 시작);
  } else {
    시작();
  }
})();
